module.exports = __webpack_public_path__ + "img/5.0aae8086.png";